import type {IGatsbyImageData} from 'gatsby-plugin-image';

type GatsbyImageFallbackLike = {
  readonly src?: string;
  readonly srcSet?: string;
  readonly sizes?: string;
};

export type GatsbyImageSourceLike = {
  readonly srcSet?: string;
  readonly sizes?: string;
  readonly type?: string;
};

type GatsbyImageImagesLike = {
  readonly fallback?: GatsbyImageFallbackLike;
  readonly sources?: ReadonlyArray<GatsbyImageSourceLike>;
};

type GatsbyImagePlaceholderLike = {
  readonly fallback?: string;
};

export type GatsbyImageDataAccess = {
  readonly images: GatsbyImageImagesLike;
  readonly placeholder?: GatsbyImagePlaceholderLike;
};

export const asGatsbyImageDataAccess = (value: IGatsbyImageData): GatsbyImageDataAccess => {
  return value as unknown as GatsbyImageDataAccess;
};

export const getFirstSrcFromSources = (sources: ReadonlyArray<GatsbyImageSourceLike> | undefined): string | null => {
  if (sources === undefined) {
    return null;
  }

  for (const source of sources) {
    if (typeof source.srcSet !== `string`) {
      continue;
    }
    const [firstCandidate] = source.srcSet.split(` `);
    if (firstCandidate.length > 0) {
      return firstCandidate;
    }
  }

  return null;
};
